// extracted by mini-css-extract-plugin
export default {"layout":"brRv25V0","content":"g_Z6NCmz","footer":"WvWxp4DZ","logo":"b97mJGoA"};